<template>
	<div id="new">
		<img class="locationhref" src="@assets/images/locationhref.jpg" alt="">
	</div>
</template>

<script>
import { alipayOrder } from "@api/order";
export default {
	name:"New",
	mounted: function() {
		var winHeight = window.screen.height;
		document.getElementById("new").style.height = winHeight + "px";
		var ua = window.navigator.userAgent.toLowerCase();
		if (ua.match(/MicroMessenger/i) == 'micromessenger') {
			return false;
		}
		var orderId = this.$route.query.orderId;
		alipayOrder(orderId).then(res => {
			location.href = res.data.result.jsConfig;
		}).catch(e => {
            this.$dialog.error(e.msg);
			this.$router.go(-1);
        })
	}
}
</script>

<style scoped>
	#new{
		background: #f28425;
	}
	.locationhref{
		display: block;
		width: 100%;
	}
</style>
